module.exports = __webpack_public_path__ + "img/iso1328-1-2013_fig09_helix-deviation-unmodified.1e78e5ac.png";